import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';

///PIPES
import { VisitCategoryPipe } from './pipes/visit-category.pipe';
import { SanitizeHtmlPipe } from './pipes/sanitize-html.pipe';
import { GroupRecordsPipe } from './pipes/group-records.pipe';
import { SafePipe } from './pipes/safe.pipe';

////SERVICES
import { UserService } from './services/user.service';
import { ServerService } from './services/server.service';

////COMPONENTS JQX WIDGETS
//import { jqxGridModule } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxgrid';
import { jqxGridComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxgrid';
import { jqxPanelComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxpanel';
import { jqxWindowComponent } from "jqwidgets-scripts/jqwidgets-ts/angular_jqxwindow";
import { jqxTextAreaComponent } from "jqwidgets-scripts/jqwidgets-ts/angular_jqxtextarea";
import { jqxInputComponent }    from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxinput';
import { jqxPasswordInputComponent }    from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxpasswordinput';
import { jqxRadioButtonComponent } from "jqwidgets-scripts/jqwidgets-ts/angular_jqxradiobutton";
import { jqxCheckBoxComponent } from "jqwidgets-scripts/jqwidgets-ts/angular_jqxcheckbox";
import { jqxDateTimeInputComponent } from "jqwidgets-scripts/jqwidgets-ts/angular_jqxdatetimeinput";
import { jqxNumberInputComponent } from "jqwidgets-scripts/jqwidgets-ts/angular_jqxNumberInput";
import { jqxTreeComponent } from "jqwidgets-scripts/jqwidgets-ts/angular_jqxtree";
import { jqxSplitterComponent } from "jqwidgets-scripts/jqwidgets-ts/angular_jqxsplitter";
import { jqxTooltipComponent } from "jqwidgets-scripts/jqwidgets-ts/angular_jqxtooltip";
import { jqxPopoverComponent } from "jqwidgets-scripts/jqwidgets-ts/angular_jqxpopover";
import { jqxDropDownListComponent } from "jqwidgets-scripts/jqwidgets-ts/angular_jqxdropdownlist";
import { jqxCalendarComponent } from "jqwidgets-scripts/jqwidgets-ts/angular_jqxcalendar";
import { jqxChartComponent } from "jqwidgets-scripts/jqwidgets-ts/angular_jqxchart";
import { jqxEditorComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxeditor';
import { jqxDragDropComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxdragdrop';


///COMPONENTS
import { HomeComponent } from './home/home.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { ErrorComponent } from './common/error/error.component';
import { LoaderPopupComponent } from './common/loader-popup/loader-popup.component';
import { LoginPopupComponent } from './common/login-popup/login-popup.component';
///import { LLRoleSwitchComponent } from './app_LL/ll-role-switch/ll-role-switch.component';
import { LlMainCanvasComponent } from './app_LL/ll-main-canvas/ll-main-canvas.component';
import { LlUserInfoComponent } from './app_LL/ll-user-info/ll-user-info.component';
import { LlModelsSpComponent } from './app_LL/ll-models-sp/ll-models-sp.component';
import { LlAdminSpComponent } from './app_LL/ll-admin-sp/ll-admin-sp.component';
import { LlModelFunctionsSpComponent } from './app_LL/ll-model-functions-sp/ll-model-functions-sp.component';
import { LlCompanysSpComponent } from './app_LL/ll-companys-sp/ll-companys-sp.component';
import { LlContactsSpComponent } from './app_LL/ll-contacts-sp/ll-contacts-sp.component';
import { LlCompanyInfoComponent } from './app_LL/ll-company-info/ll-company-info.component';
import { LlCompanyModelsSpComponent } from './app_LL/ll-company-models-sp/ll-company-models-sp.component';
import { LlCompanyModels_pulseSpComponent  } from './app_LL/ll-company-models-sp/ll-company-models_pulse-sp.component';
import { LlInfoRequestVisitsSpComponent } from './app_LL/ll-info-request-visits-sp/ll-info-request-visits-sp.component';
import { LlInfoRequestFormsSpComponent } from './app_LL/ll-info-request-forms-sp/ll-info-request-forms-sp.component';
import { LlInfoRequestEntryComponent } from './app_LL/ll-info-request-entry/ll-info-request-entry.component';
import { LlInfoRequestAddComponent } from './app_LL/ll-info-request-add/ll-info-request-add.component';
import { LlInfoRequestRemoveComponent } from './app_LL/ll-info-request-remove/ll-info-request-remove.component';
import { LlInfoRequestQuestionSwitchComponent } from './app_LL/ll-info-request-question-switch/ll-info-request-question-switch.component';
import { LlInfoRequestSpreadsheetMappingComponent } from './app_LL/ll-info-request-spreadsheet-mapping/ll-info-request-spreadsheet-mapping.component';

import { LlCmsProviderinfoDgComponent } from './app_LL/ll-cms-providerinfo-dg/ll-cms-providerinfo-dg.component';


import { LlAdminGenericDgComponent } from './app_LL/ll-admin-generic-dg/ll-admin-generic-dg.component';
import { LlModelClassesSpComponent } from './app_LL/ll-model-classes-sp/ll-model-classes-sp.component';
import { LlModelClassesLenderEditComponent } from './app_LL/ll-model-classes-lender-edit/ll-model-classes-lender-edit.component';
import { LlCompanySwitchComponent } from './app_LL/ll-company-switch/ll-company-switch.component';
import { LlModelCensusSwitchComponent } from './app_LL/ll-model-census-switch/ll-model-census-switch.component';
import { LlModelCensusGraph01Component } from './app_LL/ll-model-census-graph01/ll-model-census-graph01.component';
import { LlModelInfoComponent } from './app_LL/ll-model-info/ll-model-info.component';
import { LlModelDashComponent } from './app_LL/ll-model-dash/ll-model-dash.component';
import { LlModelCashComponent } from './app_LL/ll-model-cash/ll-model-cash.component';
import { LlModelCashSwitchComponent } from './app_LL/ll-model-cash-switch/ll-model-cash-switch.component';
import { LlModelCashUploadComponent } from './app_LL/ll-model-cash-upload/ll-model-cash-upload.component';
import { LlModelCashRulesComponent } from './app_LL/ll-model-cash-rules/ll-model-cash-rules.component';
import { LlModelCashRuleEditComponent } from './app_LL/ll-model-cash-rule-edit/ll-model-cash-rule-edit.component';
import { LlModelCashReconcileSwitchComponent } from './app_LL/ll-model-cash-reconcile-switch/ll-model-cash-reconcile-switch.component';

import { LlModelReportsSpComponent } from './app_LL/ll-model-reports-sp/ll-model-reports-sp.component';
import { LlModelReportBbcOneComponent } from './app_LL/ll-model-report-bbc-one/ll-model-report-bbc-one.component';
import { LlModelReportBbcTwoComponent } from './app_LL/ll-model-report-bbc-two/ll-model-report-bbc-two.component';
import { LlModelReportsAiStatepayersComponent } from './app_LL/ll-model-reports-ai-statepayers/ll-model-reports-ai-statepayers.component';
import { LlModelPayersSpComponent } from './app_LL/ll-model-payers-sp/ll-model-payers-sp.component';
import { LlModelLocationsSpComponent } from './app_LL/ll-model-locations-sp/ll-model-locations-sp.component';
import { LlModelLocationEditComponent } from './app_LL/ll-model-location-edit/ll-model-location-edit.component';
import { LlModelDisplaydataComponent } from './app_LL/ll-model-displaydata/ll-model-displaydata.component';
import { LlModelMetricsSpComponent } from './app_LL/ll-model-metrics-sp/ll-model-metrics-sp.component';
import { LlModelGraphOneComponent } from './app_LL/ll-model-graph-one/ll-model-graph-one.component';
import { LlModelMetricDisplayComponent } from './app_LL/ll-model-metric-display/ll-model-metric-display.component';
import { LlModelMetricGraphComponent } from './app_LL/ll-model-metric-graph/ll-model-metric-graph.component';
/*import { LlInfoRequestLisitingSpComponent } from './app_LL/ll-info-request-lisiting-sp/ll-info-request-lisiting-sp.component';*/
////import { LlInfoRequestListingModelsSpComponent } from './app_LL/ll-info-request-listing-models-sp/ll-info-request-listing-models-sp.component';
///import { LlInfoRequestListingSwitchComponent } from './app_LL/ll-info-request-listing-switch/ll-info-request-listing-switch.component';
import { LlContactSwitchComponent } from './app_LL/ll-contact-switch/ll-contact-switch.component';
import { LlContactInfoComponent } from './app_LL/ll-contact-info/ll-contact-info.component';
import { LlInfoRequestEntryQuestionComponent } from './app_LL/ll-info-request-entry-question/ll-info-request-entry-question.component';
import { LlInfoRequestWidgetGeneralComponent } from './app_LL/ll-info-request-widget-general/ll-info-request-widget-general.component';
import { LlInfoRequestWidgetDocsComponent } from './app_LL/ll-info-request-widget-docs/ll-info-request-widget-docs.component';
import { LlInfoRequestWidgetLongTextComponent } from './app_LL/ll-info-request-widget-long-text/ll-info-request-widget-long-text.component';
import { LlInfoRequestWidgetMLPComponent } from './app_LL/ll-info-request-widget-mlp/ll-info-request-widget-mlp.component';
import { LlMessagePuComponent } from './app_LL/ll-message-pu/ll-message-pu.component';
///import { LlInfoRequestListingColgrpsSpComponent } from './app_LL/ll-info-request-listing-colgrps-sp/ll-info-request-listing-colgrps-sp.component';
import { LlAdminEmailRoutinesSpComponent } from './app_LL/ll-admin-email-routines-sp/ll-admin-email-routines-sp.component';
import { LlAdminEmailRoutinesEditComponent } from './app_LL/ll-admin-email-routines-edit/ll-admin-email-routines-edit.component';
//import { LlAdminEmailTemplatesSpComponent } from './app_LL/ll-admin-email-templates-sp/ll-admin-email-templates-sp.component';
//import { LlAdminEmailTemplateEditComponent } from './app_LL/ll-admin-email-template-edit/ll-admin-email-template-edit.component';
//import { LlAdminNewslettersSpComponent } from './app_LL/ll-admin-newsletters-sp/ll-admin-newsletters-sp.component';
//import { LlAdminNewsletterViewComponent } from './app_LL/ll-admin-newsletter-view/ll-admin-newsletter-view.component';
//import { LlModelCmsCrosswalkComponent } from './app_LL/ll-model-cms-crosswalk/ll-model-cms-crosswalk.component';
import { LlModelCmsFunctionsSpComponent } from './app_LL/ll-model-cms-functions-sp/ll-model-cms-functions-sp.component';
import { LlModelPayerEditComponent } from './app_LL/ll-model-payer-edit/ll-model-payer-edit.component';
import { LlMainRoleDgComponent } from './app_LL/ll-main-role-dg/ll-main-role-dg.component';
import { LlAdminRoleCompaniesSpComponent } from './app_LL/ll-admin-role-companies-sp/ll-admin-role-companies-sp.component';
import { LlInfoRequestGraph01Component } from './app_LL/ll-info-request-graph01/ll-info-request-graph01.component';
import { LlInfoRequestDashboardComponent } from './app_LL/ll-info-request-dashboard/ll-info-request-dashboard.component';
import { LlInfoRequestDashboardGraphComponent } from './app_LL/ll-info-request-dashboard-graph/ll-info-request-dashboard-graph.component';
import { LlInfoRequestForumComponent } from './app_LL/ll-info-request-forum/ll-info-request-forum.component';
import { LlInfoRequestForumThreadComponent } from './app_LL/ll-info-request-forum-thread/ll-info-request-forum-thread.component';

import { LlLoanmgmtBBCSpComponent } from './app_LL/ll-loanmgmt-bbc-sp/ll-loanmgmt-bbc-sp.component';
import { LlLoanmgmtLoanRecordComponent } from './app_LL/ll-loanmgmt-loanrecord/ll-loanmgmt-loanrecord.component';
import { LlLoanmgmtBBCComponent } from './app_LL/ll-loanmgmt-bbc/ll-loanmgmt-bbc.component';
import { LlLoanmgmtBBCSwitchComponent } from './app_LL/ll-loanmgmt-bbc-switch/ll-loanmgmt-bbc-switch.component';
import { LlLoanmgmtBbcSettingsComponent } from './app_LL/ll-loanmgmt-bbc-settings/ll-loanmgmt-bbc-settings.component';
import { LlLoanmgmtBbcDisplayComponent } from './app_LL/ll-loanmgmt-bbc-display/ll-loanmgmt-bbc-display.component';
import { LlModelCollateralEditComponent } from './app_LL/ll-model-collateral-edit/ll-model-collateral-edit.component';
import { LlModelCollateralEditModelComponent } from './app_LL/ll-model-collateral-edit-model/ll-model-collateral-edit-model.component';
import { LlModelPortfolioSwitchComponent } from './app_LL/ll-model-portfolio-switch/ll-model-portfolio-switch.component';
import { LlModelPermissionsComponent } from './app_LL/ll-model-permissions/ll-model-permissions.component';

import { LlBuildVisitsSpComponent } from './app_LL/ll-build-visits-sp/ll-build-visits-sp.component';
import { LlBuildVisitFormsSpComponent } from './app_LL/ll-build-visit-forms-sp/ll-build-visit-forms-sp.component';
import { LlBuildFormHolderComponent } from './app_LL/ll-build-form-holder/ll-build-form-holder.component';
import { LlBuildFormComponent } from './app_LL/ll-build-form/ll-build-form.component';

import { LlExamSpComponent } from './app_LL/ll-exam-sp/ll-exam-sp.component';
import { LlExamSectionsSpComponent } from './app_LL/ll-exam-sections-sp/ll-exam-sections-sp.component';
import { LlExamSectionsScopeComponent } from './app_LL/ll-exam-sections-scope/ll-exam-sections-scope.component';
import { LlExamSectionsBBCComponent } from './app_LL/ll-exam-sections-bbc/ll-exam-sections-bbc.component';
import { LlExamSectionsReceivablesComponent } from './app_LL/ll-exam-sections-receivables/ll-exam-sections-receivables.component';
import { LlExamSectionsPayablesComponent } from './app_LL/ll-exam-sections-payables/ll-exam-sections-payables.component';
import { LlExamSectionsCashComponent } from './app_LL/ll-exam-sections-cash/ll-exam-sections-cash.component';
import { LlExamSectionsOccupancyComponent } from './app_LL/ll-exam-sections-occupancy/ll-exam-sections-occupancy.component';
import { LlExamSectionsLocationsComponent } from './app_LL/ll-exam-sections-locations/ll-exam-sections-locations.component';

@NgModule({
  declarations: [
    AppComponent,
    NotFoundComponent,
    HomeComponent,    
    jqxGridComponent,
    jqxPanelComponent,
    jqxWindowComponent,
    jqxTextAreaComponent,
    jqxInputComponent,
    jqxPasswordInputComponent,
    jqxRadioButtonComponent,
    jqxCheckBoxComponent,
    jqxDateTimeInputComponent,
    jqxNumberInputComponent,
    jqxTreeComponent,
    jqxSplitterComponent,
    jqxTooltipComponent,
    jqxPopoverComponent,
    jqxDropDownListComponent, 
    jqxCalendarComponent,  
    jqxChartComponent,
    jqxEditorComponent,
    jqxDragDropComponent,

    VisitCategoryPipe,
    SanitizeHtmlPipe,
    GroupRecordsPipe,
    SafePipe,
    ErrorComponent,
    LoaderPopupComponent,
    LoginPopupComponent,
    ///LLRoleSwitchComponent,
    LlMainCanvasComponent,
    LlUserInfoComponent,
    LlModelsSpComponent,
    LlAdminSpComponent,
    LlModelFunctionsSpComponent,
    LlCompanysSpComponent,
    LlContactsSpComponent,
    LlCompanyInfoComponent,
    LlCompanyModelsSpComponent,
    LlCompanyModels_pulseSpComponent,
    LlInfoRequestVisitsSpComponent,
    LlInfoRequestFormsSpComponent,
    LlInfoRequestEntryComponent,
    LlInfoRequestAddComponent,
    LlInfoRequestRemoveComponent,
    LlInfoRequestQuestionSwitchComponent,
    LlInfoRequestSpreadsheetMappingComponent,
    LlCmsProviderinfoDgComponent,
    LlAdminGenericDgComponent,
    LlModelClassesSpComponent,
    LlModelClassesLenderEditComponent,
    LlCompanySwitchComponent,
    LlModelCensusGraph01Component,
    LlModelCensusSwitchComponent,
    LlModelInfoComponent,
    LlModelDashComponent,
    LlModelCashComponent,
    LlModelCashSwitchComponent,
    LlModelCashUploadComponent,
    LlModelCashRulesComponent,
    LlModelCashRuleEditComponent,
    LlModelCashReconcileSwitchComponent,
    LlModelReportsSpComponent,
    LlModelReportBbcOneComponent,
    LlModelReportBbcTwoComponent,
    LlModelReportsAiStatepayersComponent,
    LlModelPayersSpComponent,
    LlModelLocationsSpComponent,
    LlModelLocationEditComponent,
    LlModelDisplaydataComponent,
    LlModelMetricsSpComponent,
    LlModelGraphOneComponent,
    LlModelMetricDisplayComponent,
    LlModelMetricGraphComponent,   
    /*LlInfoRequestLisitingSpComponent,*/
    ///LlInfoRequestListingModelsSpComponent,
    ///LlInfoRequestListingSwitchComponent,
    LlContactSwitchComponent,
    LlContactInfoComponent,
    LlInfoRequestEntryQuestionComponent,
    LlInfoRequestWidgetGeneralComponent,
    LlInfoRequestWidgetDocsComponent,
    LlInfoRequestWidgetLongTextComponent,
    LlInfoRequestWidgetMLPComponent,
    LlMessagePuComponent,
    ///LlInfoRequestListingColgrpsSpComponent,
    LlAdminEmailRoutinesSpComponent,
    LlAdminEmailRoutinesEditComponent,
    //LlAdminEmailTemplatesSpComponent,
    //LlAdminEmailTemplateEditComponent,
    //LlAdminNewslettersSpComponent,
    //LlAdminNewsletterViewComponent,
    //LlModelCmsCrosswalkComponent,
    LlModelCmsFunctionsSpComponent,
    LlModelPayerEditComponent,    
    LlMainRoleDgComponent,
    LlAdminRoleCompaniesSpComponent,
    LlInfoRequestGraph01Component,
    LlInfoRequestDashboardComponent,
    LlInfoRequestDashboardGraphComponent,
    LlInfoRequestForumComponent,
    LlInfoRequestForumThreadComponent,
    LlLoanmgmtBBCSpComponent,
    LlLoanmgmtLoanRecordComponent,
    LlLoanmgmtBBCComponent,
    LlLoanmgmtBBCSwitchComponent,
    LlLoanmgmtBbcSettingsComponent,
    LlLoanmgmtBbcDisplayComponent,
    LlModelCollateralEditComponent,
    LlModelCollateralEditModelComponent,
    LlModelPortfolioSwitchComponent,
    LlModelPermissionsComponent,
    LlBuildVisitsSpComponent,
    LlBuildVisitFormsSpComponent,
    LlBuildFormHolderComponent, 
    LlBuildFormComponent,
    LlExamSpComponent,
    LlExamSectionsSpComponent,
    LlExamSectionsScopeComponent,
    LlExamSectionsBBCComponent,
    LlExamSectionsReceivablesComponent,
    LlExamSectionsPayablesComponent,
    LlExamSectionsCashComponent,
    LlExamSectionsOccupancyComponent,
    LlExamSectionsLocationsComponent,
  ],

  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    AppRoutingModule,

  ],
  providers: [
    UserService,
    ServerService,
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
